import { LinearProgress } from "@mui/material";
import { DataGridPro } from "@mui/x-data-grid-pro";
import { useContext, useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { gettingTags } from "utils/Filter";
import { Context } from "../Context";
import { Orgpath } from "./Orgpath";

const Step2 = () => {
	const { t } = useTranslation();

	const {
		setEmployees,
		loadingEmployees,
		setLoadingEmployees,
		range,
		selectedEmployees,
		setSelectedEmployees,
	} = useContext(Context);

	const [rows, setRows] = useState([]);
	const [tags, setTags] = useState([]);

	const columns = useMemo(
		() => [
			{
				field: "person_number",
				headerName: t(
					"custom_reports.execute_reports.stepper.step2.table.columns.person_number"
				),
				flex: 1,
				minWidth: 150,
			},
			{
				field: "full_name",
				headerName: t(
					"custom_reports.execute_reports.stepper.step2.table.columns.full_name"
				),
				flex: 1,
				minWidth: 150,
			},
			{
				field: "orgpath",
				headerName: t(
					"custom_reports.execute_reports.stepper.step2.table.columns.org_path"
				),
				flex: 2,
				minWidth: 250,
				renderCell: (params) => <Orgpath params={params} />,
			},
			{
				field: "tags",
				headerName: t(
					"custom_reports.execute_reports.stepper.step2.table.columns.tag"
				),
				flex: 1,
				minWidth: 150,
				valueGetter: (params) => {
					return tags
						.filter((tag) =>
							params.map((t) => t.tag_id).includes(tag.id)
						)
						.map((tag) => tag.name)
						.join(", ");
				},
			},
		],
		[t, tags]
	);

	useEffect(() => {
		gettingTags(
			setLoadingEmployees,
			setTags,
			() => {},
			setEmployees,
			() => {},
			setRows,
			"employee",
			{
				start_date: range[0].format("YYYY-MM-DD"),
				end_date: range[1].format("YYYY-MM-DD"),
				without_hiring: false,
			}
		);
	}, [range, setEmployees, setLoadingEmployees]);

	return (
		<>
			<DataGridPro
				showCellVerticalBorder
				showColumnVerticalBorder
				checkboxSelection
				loading={loadingEmployees}
				columns={columns}
				rows={rows}
				slots={{
					loadingOverlay: LinearProgress,
				}}
				rowSelectionModel={selectedEmployees}
				onRowSelectionModelChange={(newRowSelectionModel) => {
					setSelectedEmployees(newRowSelectionModel);
					console.log("newRowSelectionModel", newRowSelectionModel);
				}}
				sx={{
					m: "3.5vw",
					height: `calc(100vh - 450px)`,
				}}
				hideFooter
				//disableRowSelectionOnClick
				getRowHeight={(params) => {
					const { model } = params;

					let length = 64;

					for (const key of Object.keys(model).filter((k) =>
						Array.isArray(model[k])
					)) {
						if (key === "orgpath") {
							//console.log(key, model[key]);

							let counter = 0;

							if (model[key].length > 0) {
								counter = counter + model[key].length * 55;
							}

							if (counter > length) {
								length = counter;
							}
						}
					}

					return length;
				}}
			/>
		</>
	);
};

export { Step2 };
